<template>
    <div class="editDialog">
        <el-dialog
            :title="isEdit ? '修改' : '新建'"
            :visible.sync="dialogShow"
            :before-close="handleClose"
            width="700px"
            :close-on-click-modal="false"
        >
            <div class="content">
                <el-form
                    :inline="true"
                    :model="formEdit"
                    label-width="80px"
                    :rules="rules"
                    :ref="refName"
                >
                    <div class="el-form-area">
                        <el-form-item label="客户" prop="companyId">
                            <el-select v-model="formEdit.companyId" placeholder="请选择客户" clearable>
                                <el-option
                                    v-for="(item, index) in companyList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="登录账号" prop="loginName">
                            <el-input v-model="formEdit.loginName" placeholder="请输入登录账号" clearable maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="用户姓名" prop="userName">
                            <el-input v-model="formEdit.userName" placeholder="请输入用户姓名" clearable maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-radio-group v-model="formEdit.sex">
                                <el-radio label="MALE">男</el-radio>
                                <el-radio label="FEMALE">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="用户角色" prop="roles">
                            <el-select v-model="formEdit.role" placeholder="请选择用户角色" clearable>
                                <el-option
                                    v-for="(item, index) in roleList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="联系方式" prop="mobile">
                            <el-input v-model="formEdit.mobile" placeholder="请输入手机号码" clearable maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="formEdit.email" placeholder="请填写邮箱" clearable maxlength="50"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit">确定</el-button>
                <el-button @click="handleClose">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import editDialogMixin from '@/mixins/editDialogMixin';
import { validateMobile, validateEmail } from '@/common/validate';
export default {
    mixins: [editDialogMixin],
    props: {
        companyList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        const loginNumber = (rule, val, callback) => {
            if (val.length < 4) {
                callback(new Error('请输入至少4位的登陆账号'));
            } else {
                callback();
            }
        };
        return {
            roleList: [], // 角色列表
            formReset: {
                userId: null,
                userName: '',
                loginName: '',
                sex: 'MALE',
                role: null,
                mobile: '',
                email: '',
                companyId: null
            },
            rules: {
                mobile: [
                    {
                        required: true,
                        message: '手机号码不能为空',
                        trigger: 'blur'
                    },
                    {
                        validator: validateMobile,
                        trigger: 'blur'
                    }
                ],
                email: [
                    {
                        validator: validateEmail,
                        trigger: 'blur'
                    }
                ],
                loginName: [
                    {
                        required: true,
                        message: '请输入至少4位的登陆账号',
                        trigger: 'blur'
                    },
                    {
                        validator: loginNumber,
                        trigger: 'blur'
                    }
                ],
                userName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                role: [
                    {
                        required: true,
                        message: '角色不能为空',
                    }
                ],
                companyId: [
                    {
                        required: true,
                        message: '养护单位不能为空'
                    }
                ]
            },
            // 与用户类型相关联表单是否显示
            companyShow: false
        };
    },
    watch: {
        'formEdit.companyId': {
            handler(newValue, oldValue) {
                // 根据用户类型获取用户角色列表
                this.$http
                    .get('/account/roles/v1',{
                        companyId: newValue
                    })
                    .then(res => {
                        this.roleList = res;
                        // 新建时切换用户类型，重置部分表单
                        if (!this.isEdit) {
                            this.formEdit.roles = this.formReset.role;
                        }
                        this.clearField();
                        // switch (newValue) {
                        //     case 'SUPERVISOR':
                        //     case 'COMPANY':
                        //         this.ageShow = true;
                        //         this.jobShow = true;
                        //         this.companyShow = true;
                        //         break;
                        //     case 'GOVERNMENT':
                        //     default:
                        //         this.ageShow = false;
                        //         this.jobShow = false;
                        //         this.companyShow = false;
                        // }
                    });
            }
        }
    },
    methods: {
        handleSubmit() {
            this.$refs[this.refName].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.$http
                            .post(
                                this.isEdit
                                    ? '/account/edit/v1'
                                    : '/account/create/v1',
                                this.formEdit,
                                '提交中……',
                                this.isEdit ? '修改成功' : '新建成功'
                            )
                            .then(res => {
                                this.$emit('updateData');
                                this.handleClose();
                            });
                    });
                }
            });
        }
    }
};
</script>